<template>
  <span
    @click="handleClick"
    @keydown.enter="handleClick"
    @keydown.space="handleClick"
    v-if="isReactionsVisible"
    v-tooltip="{
      content: iconTooltipContent,
      offset: 0,
    }"
    class="flex items-center"
    tabindex="0"
    role="button"
    :aria-label="`View reactions: ${numberOfReactions} total reactions`"
  >
    <img
      v-for="(reaction, index) in reactions"
      :key="reaction.iconName"
      :src="reaction.icon"
      :alt="reaction.iconName"
      width="16"
      height="16"
      class="inline-block"
      :class="{ '-mr-0.5 relative': index === 0 }"
    >
    <span class="ml-1 text-xs text-base-80" :class="{ 'text-reaction-report': isReport }">
      <AhaFormatter :value="numberOfReactions" :locale="presentation.language" type="KMB" />
    </span>
  </span>
</template>

<script>
// icons
import like from '@/assets/images/reactions/like.svg'
import heart from '@/assets/images/reactions/heart.svg'
import laugh from '@/assets/images/reactions/laugh.svg'
import sad from '@/assets/images/reactions/sad.svg'
import wow from '@/assets/images/reactions/wow.svg'
import { mapActions, mapGetters } from 'vuex'

export const reactionTypes = [[like, 'like'], [heart, 'heart'], [laugh, 'laugh'], [wow, 'wow'], [sad, 'sad']]

export default {
  props: {
    presentation: {
      type: Object,
      required: true,
    },
    isReport: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('liveStatsV2', ['reactionCountPerType']),
    reactionCount() {
      return (reactionType) => {
        if (!this.presentation) return 0
        const count = parseInt(this.reactionCountPerType(
          this.presentation.id,
          this.presentation.version, reactionType,
        ), 10)
        return Number.isNaN(count) ? 0 : count
      }
    },

    iconTooltipContent() {
      let text = ''
      reactionTypes.forEach((item) => {
        const [icon, iconName] = item
        const reactionCount = this.reactionCount(iconName)
        if (reactionCount) {
          text += `
            <img class='inline-block mr-1' src='${icon}' width='16' height='16' />
            <span class='number-of-reactions'>${this.$func.formatter(reactionCount, 'KMB', this.presentation.language)}</span>
          `
        }
      })
      return `<div class='flex items-center'>${text}</div>`
    },

    reactions() {
      const reactions = reactionTypes.map((item) => {
        const [icon, iconName] = item
        return {
          icon,
          iconName,
          numberOfReactions: this.reactionCount(iconName),
        }
      })

      return reactions
        .filter((reaction) => reaction.numberOfReactions)
        .sort((a, b) => b.numberOfReactions - a.numberOfReactions)
        .slice(0, 2)
    },
    isReactionsVisible() {
      return this.reactions.length > 0
    },

    numberOfReactions() {
      return reactionTypes.reduce((total, current) => {
        const [, iconName] = current
        total += this.reactionCount(iconName)
        return total
      }, 0)
    },
  },
  async mounted() {
    if (this.presentation && this.presentation.id) {
      await this.fetchReactionsByPresentation({
        presentation: this.presentation,
      })
    }
  },
  methods: {
    ...mapActions('liveStatsV2', [
      'fetchReactionsByPresentation',
    ]),
    handleClick(e) {
      this.$emit('click', e)
    },
  },

}
</script>

<style lang="scss" scoped>
.number-of-reactions {
  @apply mr-3;

  &:last-child {
    @apply mr-0;
  }
}

.text-reaction-report {
  font-size: 16px;
}
</style>
